import {metrics} from '../utils/metrics.js';
import { Component } from 'react';

// Keep controls outside the renderer usable when WebGL or imagery fails.
export default class RendererBoundary extends Component {
  state = { failed: false, attempt: 0 };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(error) { metrics.failure('loading-initialization','globe'); console.error('[renderer]', error); }
  render() {
    if (this.state.failed) return (
      <div role="alert" style={{ padding: 24, color: 'var(--txt-bright)', background: 'var(--bg)' }}>
        <p>The globe could not load. You can still use the other views.</p>
        <button style={{ color: 'var(--accent)', background: 'var(--bg-2)', border: '1px solid var(--accent)', padding: '8px 12px', cursor: 'pointer' }} onClick={() => {metrics.retry('globe');this.setState(s => ({ failed: false, attempt: s.attempt + 1 }));}}>Retry globe</button>
      </div>
    );
    return <div key={this.state.attempt} style={{ width: '100%', height: '100%' }}>{this.props.children}</div>;
  }
}
